import { render, staticRenderFns } from "./supplementaryList.vue?vue&type=template&id=5fbeaeab"
import script from "./supplementaryList.vue?vue&type=script&lang=js"
export * from "./supplementaryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports